// src/components/ShoppingCart.js
import React, { useEffect, useState } from "react";
import Topbar from "./Navigations/Topbar";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import {
  deleteCart,
  getCartProductsByCustomerId,
  updateCart,
} from "../../service/CartService";
import { fetchProductImage } from "../../service/ProductImageService";
import { fetchAllCustomerProduct } from "../../service/ProductService";
import { apiUrl } from "../../config";
import { useToast } from "../toast/ToastProvider";
import { formatINR } from "../../App";
import { useSelector } from "react-redux";
import { Trash } from "react-feather";
import { getWishlistProductsByCustomerId } from "../../service/WishlistService";

const ShoppingCart = () => {
  const toast = useToast();
  const authUser = useSelector((state) => state.auth.authUser);
  const [loading, setLoading] = useState(true);
  const [displayCart, setDisplayCart] = useState([]);
  const [cart, setCart] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  const fetchData = async () => {
    if (!authUser?.id) {
      setLoading(false);
      setDisplayCart([]);
      return;
    }

    try {
      const cartData = await getCartProductsByCustomerId(authUser.id);
      const productImageData = await fetchProductImage();
      const productsData = await fetchAllCustomerProduct();
      const response = await getWishlistProductsByCustomerId(authUser.id);
      setCart(cartData);
      setWishlist(response);

      // Build enriched cart with product details
      const imageMap = {};
      productImageData.forEach((img) => {
        if (!imageMap[img.productId]) imageMap[img.productId] = [];
        imageMap[img.productId].push(img);
      });

      const productMap = {};
      productsData.forEach((p) => {
        productMap[p.id] = p;
      });

      const enriched = cartData.map((item) => {
        const product = productMap[item.productId] || {};
        return {
          ...item,
          name: product.name || "Unknown",
          ornamentPrice: product.ornamentPrice || 0,
          mrp: product.mrp || 0,
          rating: product.rating || 4,
          images: imageMap[item.productId] || [],
          quantity: item.quantity || 1,
        };
      });
      setDisplayCart(enriched);
    } catch (error) {
      console.error("Error fetching cart:", error);
      toast("Failed to load cart items", "ERROR");
      setDisplayCart([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [authUser?.id]);

  const getProductImageUrl = (product) => {
    if (product.images?.length > 0) {
      return `${apiUrl}/${product.images[0].imageUrl}`;
    }
    return "/default-product.png";
  };

  const handleDelete = async (cartId) => {
    if (window.confirm("Are you sure you want to remove this product?")) {
      try {
        await deleteCart(cartId);
        toast("Item removed from cart", "SUCCESS");
        // Remove from local state immediately
        setDisplayCart((prev) => prev.filter((item) => item.cartId !== cartId));
      } catch (error) {
        console.error("Delete error:", error);
        toast("Failed to remove item", "ERROR");
      }
    }
  };

  const handleQuantityChange = async (cartId, newQuantity) => {
    const numValue = parseInt(newQuantity, 10);
    if (isNaN(numValue) || numValue < 1 || numValue > 10) return;

    const item = displayCart.find((i) => i.cartId === cartId);
    if (!item) return;

    try {
      // Call your update API: updateCart(id, data)
      await updateCart(cartId, {
        id: cartId,
        customerId: item.customerId,
        productId: item.productId,
        quantity: numValue,
      });

      // Optimistically update UI
      setDisplayCart((prev) =>
        prev.map((i) =>
          i.cartId === cartId ? { ...i, quantity: numValue } : i,
        ),
      );
      toast("Quantity updated", "SUCCESS");
    } catch (error) {
      console.error("Update error:", error);
      toast("Failed to update quantity", "ERROR");
      // Optionally revert UI on error
    }
  };
  const getDiscountPrice = (item) => {
  const price = item.ornamentPrice || 0;
  const discount = item.discount || 0;
  const beforeGst = item.priceBeforeGst || 0;

  if (discount > 0) {
    return Math.round(price - (beforeGst * discount) / 100);
  }

  return Math.round(price);
};
  const totalPrice = displayCart.reduce((acc, item) => {
  const discountPrice = getDiscountPrice(item);
  return acc + discountPrice * item.quantity;
}, 0);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <header className="header style7">
        <Topbar />
      </header>
      <div className="container py-5">
        <h3 className="fw-bold" style={{ fontSize: "30px" }}>
          Shopping Cart
        </h3>
        {displayCart.length === 0 ? (
          <div className="text-center py-5">
            <h4 className="text-muted mb-3" style={{ fontSize: "30px" }}>
              Your Shopping Cart is Empty!
            </h4>
            <Link
              to="/products"
              className="btn btn-primary"
              style={{ padding: "10px", fontSize: "16px" }}
            >
              Continue Shopping
            </Link>
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-8">
              <div className="bg-white rounded-3 p-4 shadow-sm mt-3">
                {displayCart.map((data) => {
                  console.log(data);
                  const discountPrice = getDiscountPrice(data);
                  console.log("dis", discountPrice);

                  return (
                    <div
                      key={data.cartId}
                      className="d-flex border-bottom pb-4 mb-4"
                    >
                      <div className="flex-shrink-0 me-4">
                        <Link to={`/${data.productId}`}>
                          <img
                            src={getProductImageUrl(data)}
                            alt={data.name}
                            className="img-fluid rounded"
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                            }}
                          />
                        </Link>
                      </div>
                      <div className="flex-grow-1">
                        <div className="d-flex justify-content-between">
                          <h5 className="fw-bold fs-2 mb-3">{data.name}</h5>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(data.cartId)}
                          >
                            <Trash size={16} />
                          </button>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <span className="badge fs-5 bg-success me-2">
                            {data.rating} ★
                          </span>
                          <span className="text-muted fs-5 small">
                            (4 Reviews)
                          </span>
                        </div>
                        <div className="mt-2 mb-3">
                          <span className="h5 fw-bold fs-3 text-dark">
                            {formatINR(discountPrice)}
                          </span>
                          {data.mrp > data.ornamentPrice && (
                            <span className="text-muted ms-2 text-decoration-line-through">
                              {formatINR(data.mrp)}
                            </span>
                          )}
                        </div>
                        <div className="d-flex align-items-center">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={data.quantity}
                            onChange={(e) =>
                              handleQuantityChange(data.cartId, e.target.value)
                            }
                          >
                            {[...Array(10)].map((_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </select>
                          <div className="ms-3 fw-bold fs-4">
                            {formatINR(discountPrice * data.quantity)}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="bg-white rounded-3 p-4 shadow-sm">
                <h5 className="fw-bold fs-3 mb-4 pb-2 border-bottom">
                  PRICE DETAILS
                </h5>
                <div className="mb-3">
                  {displayCart.map((item) => {
                    const discoutntPrice =getDiscountPrice(item);
                     
                    return (
                      <div
                        key={item.cartId}
                        className="d-flex justify-content-between mb-2 fs-4"
                      >
                        <span>
                          {item.name} × {item.quantity}
                        </span>
                        <span>
                          {formatINR(
                            Math.round(discoutntPrice * item.quantity),
                          )}
                        </span>
                      </div>
                    );
                  })}
                </div>
                <hr className="my-3" />
                <div className="d-flex justify-content-between fw-bold fs-5">
                  <span>Total Amount</span>
                  <span>{formatINR(Math.round(totalPrice))}</span>
                </div>
                <Link to="/check-out" className="w-100">
                  <button
                    className="btn btn-warning w-100 py-3 mt-4 fw-bold"
                    style={{
                      backgroundColor: "#121535",
                      borderColor: "white",
                      borderRadius: "20px",
                      color: "white",
                      fontSize: "12px",
                    }}
                  >
                    Proceed to Checkout
                  </button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
      <div className="footer-device-mobile">
        <div className="wapper">
          <div className="footer-device-mobile-item device-home">
            <Link to="/" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-house"></i>
              </span>{" "}
              Home
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/wishlist" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-heart"></i>
                <span className="count-icon">{wishlist.length}</span>
              </span>{" "}
              Wishlist
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-cart">
            <Link to="/shopping-cart" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-shopping-cart-simple" />
                <span className="count-icon">{cart.length}</span>
              </span>{" "}
              Cart
            </Link>
          </div>
          <div className="footer-device-mobile-item device-home device-user">
            <Link to="/profile" className="text-decoration-none">
              <span className="icon">
                <i className="ph ph-user"></i>
              </span>{" "}
              Account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCart;
